import store from "@/store"

import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"
import { timeout } from "@/utils/common"

export default {
  emailNotReceived(email, $) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/registration/resend-confirm-email", {
        email: email
      })
        .then(response => {
          $.$store.commit("app/success", "E-mail sent")
          resolve(response)
        })
        .catch(error => {
          let msg = error.response.data.error?.join("\n") || "unexpected error"
          $.$store.commit("app/message", { msg: msg, color: "error" })
          reject(error)
        })
    })
  },
  profile($) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/settings/profile")
        .then(r => {
          resolve(r.data)
        })
        .catch(error => {
          $.$store.commit("app/message", {
            msg: "Request failed: Retrieving user information",
            color: "error"
          })
          reject(error)
        })
    })
  },
  updateProfileInfo($, firstName, lastName, username) {
    return new Promise((resolve, reject) => {
      HTTP.put("/account/profile", {
        first_name: firstName,
        last_name: lastName,
        username
      })
        .then(function (response) {
          $.$store.state.app.user.first_name = firstName
          $.$store.state.app.user.last_name = lastName
          $.$store.commit("app/success", "Profile updated")
          resolve(response)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  changePassword($, old, new1, new2) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/password/change", {
        new_password1: new1,
        new_password2: new2,
        old_password: old
      })
        .then(function (response) {
          $.$store.commit("app/success", "Password updated")
          resolve(response)
        })
        .catch(function (error) {
          const err = error.response.data
          for (const prop in err) {
            $.$store.commit("app/message", {
              msg: prop + " : " + err[prop],
              color: "error"
            })
          }
          reject(error)
        })
    })
  },
  resetPassword(email, $) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/password/reset", { email: email })
        .then(response => {
          $.$store.commit("app/success", "E-mail sent")
          resolve(response)
        })
        .catch(error => {
          $.$store.commit("app/message", { text: error, color: "error" })
          reject(error)
        })
    })
  },
  sendNewPassword($, password1, password2, uid, key) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/password/reset/confirm", {
        uid: uid,
        token: key,
        new_password1: password1,
        new_password2: password2
      })
        .then(async response => {
          resolve(response)
          $.$store.commit("app/success", "Password updated. Try to login with your new password")
          await timeout(1000)
          $.$router.replace("/signin")
        })
        .catch(error => {
          $.$store.commit("app/message", { text: error, color: "error" })
          reject(error)
        })
    })
  },
  getInvitation($, invitation_key) {
    return new Promise((resolve, reject) => {
      HTTP.post("/projects/team/get_invitation", {
        key: invitation_key
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
          $.$store.commit("app/message", { text: error, color: "error" })
        })
    })
  },
  acceptInvitation($, invitation_key) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/invitations/accept/${invitation_key}`)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  login($, creds, redirect) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/login", {
        email: creds.email,
        password: creds.password,
        recaptchaToken: creds.recaptchaToken
      })
        .then(async response => {
          if (response.data.mfa_required) {
            // Rediriger vers la page MFA si l'authentification nécessite un MFA
            $.$router.push({
              name: "Verification",
              query: { temp_token: response.data.temp_token }
            })
          } else {
            $.$store.commit("app/setUser", response.data)
            $.$store.dispatch("app/fetchNotifications")
            await timeout(500)
            redirect = redirect || { name: "Home" }
            $.$router.push(redirect)
            resolve(response)
          }
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  logout() {
    store.commit("app/clearSession")
    return HTTP.post("/account/logout")
  },
  registerEmailValidation($, key) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/account/registration/verify-email`, {
        key: key
      })
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  register($, account) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/registration", account)
        .then(function (response) {
          resolve(response)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  sendMfa($, account, redirect) {
    return new Promise((resolve, reject) => {
      HTTP.post("/account/mfa/verify", account)
        .then(async response => {
          $.$store.commit("app/setUser", response.data)
          $.$store.dispatch("app/fetchNotifications")
          await timeout(500)
          redirect = redirect || { name: "Home" }
          $.$router.push(redirect)
          resolve(response)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  postSignature($, imageData) {
    if (imageData) {
      const formData = new FormData()
      formData.append("image", imageData)
      return new Promise((resolve, reject) => {
        HTTP.post(`/account/signatures`, formData)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getSignatures() {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/signatures`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  selfRemoveSignatures($, companyId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/account/signatures`).then(r => {
        resolve(r.data)
      })
    })
  },
  toggleMFA(data) {
    return HTTP.post("/account/toggle-mfa", data)
  },
  getMFAStatus() {
    return HTTP.get("/account/mfa-status")
  }
}
